import { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PortfolioGallery = ({ workerId }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Mock portfolio data (in production, fetch from Supabase)
  const portfolioItems = [
  {
    id: 1,
    imageUrl: "https://images.unsplash.com/photo-1722348672168-a7ed6261fc78",
    title: 'Home Renovation Project',
    description: 'Complete kitchen and living room renovation with modern design',
    alt: 'Modern kitchen renovation with white cabinets and marble countertops'
  },
  {
    id: 2,
    imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1a711fe67-1766961751025.png",
    title: 'Electrical Installation',
    description: 'Professional electrical wiring and lighting installation',
    alt: 'Electrician installing modern LED lighting fixtures'
  },
  {
    id: 3,
    imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1dfd466b2-1769422079548.png",
    title: 'Plumbing Repair',
    description: 'Complete bathroom plumbing system upgrade',
    alt: 'Professional plumber repairing bathroom fixtures'
  },
  {
    id: 4,
    imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3efb5c5-1770202158455.png",
    title: 'Carpentry Work',
    description: 'Custom furniture and cabinet installation',
    alt: 'Carpenter building custom wooden cabinets'
  }];


  if (portfolioItems?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6">
      <h2 className="text-xl font-bold text-foreground mb-6 flex items-center gap-2">
        <Icon name="Image" className="w-5 h-5 text-primary" />
        Portfolio Gallery
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {portfolioItems?.map((item) =>
        <div
          key={item?.id}
          className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer border border-border hover:border-primary transition-all"
          onClick={() => setSelectedImage(item)}>

            <img
            src={item?.imageUrl}
            alt={item?.alt}
            className="w-full h-full object-cover transition-transform group-hover:scale-110" />

            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <p className="text-white text-sm font-medium line-clamp-2">
                  {item?.title}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Image Modal */}
      {selectedImage &&
      <div
        className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
        onClick={() => setSelectedImage(null)}>

          <div
          className="bg-card rounded-lg max-w-4xl w-full max-h-[90vh] overflow-auto"
          onClick={(e) => e?.stopPropagation()}>

            <div className="relative">
              <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 w-10 h-10 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center text-white transition-colors z-10">

                <Icon name="X" className="w-5 h-5" />
              </button>
              <img
              src={selectedImage?.imageUrl}
              alt={selectedImage?.alt}
              className="w-full h-auto max-h-[60vh] object-contain" />

            </div>
            <div className="p-6">
              <h3 className="text-xl font-bold text-foreground mb-2">
                {selectedImage?.title}
              </h3>
              <p className="text-muted-foreground">
                {selectedImage?.description}
              </p>
            </div>
          </div>
        </div>
      }
    </div>);

};

export default PortfolioGallery;